import { configureStore, getDefaultMiddleware } from "@reduxjs/toolkit";
import loggerMiddleware from "redux-logger";
import logger from "redux-logger";
import {
  ApolloClient,
  InMemoryCache,
  HttpLink,
  ApolloLink,
} from "@apollo/client";
// import { composeWithDevTools } from 'redux-devtools-extension';
import { Provider, useDispatch } from "react-redux";
import { setContext } from "@apollo/client/link/context";
import rootReducer from "./reducer/reducer";
import { thunk } from "redux-thunk";

function getApiUrl() {
  let _baseApiUrl = process.env.REACT_APP_API_URL ?? "/api";
  if (_baseApiUrl.indexOf("/") !== 0) {
    _baseApiUrl = `/${_baseApiUrl}`;
  }
  return _baseApiUrl;
}

export const baseApiUrl = getApiUrl();
console.log('process.env',process.env);


// const httpLink = new HttpLink({ uri: `${baseApiUrl}/graphql` });
const httpLink = new HttpLink({
  uri: `${process.env.REACT_APP_BACKEND_URL}/api/graphql`,
});

const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem("token");

  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
    },
  };
});


const client = new ApolloClient({
  link: ApolloLink.from([authLink, httpLink]),
  // link: ApolloLink.from([authLink, corsLink, httpLink]),
  cache: new InMemoryCache({
    typePolicies: {
      Query: {
        fields: {
          __typename: {
            read() {
              return undefined;
            },
          },
        },
      },
    },
  }),
});

// const store = configureStore({
//   reducer: rootReducer,

//   middleware: (getDefaultMiddleware) =>
//     getDefaultMiddleware({
//       thunk: {
//         extraArgument: { client },
//       },
//     }).concat(logger),
// });

const store = configureStore({
  reducer: rootReducer,

  middleware: (getDefaultMiddleware) => {
    const customMiddleware = (store) => (next) => (action) => {
      if (action.type.endsWith("_REQUEST")) {
        store.dispatch({ type: 'START_LOADING' });
      } else if (action.type.endsWith("_SUCCESS") || action.type.endsWith("_FAILURE")) {
        store.dispatch({ type: 'STOP_LOADING' });
      }
      return next(action);
    };

    return getDefaultMiddleware({
      thunk: {
        extraArgument: { client },
      },
    }).concat(loggerMiddleware, customMiddleware);
  }
});

if (process.env.NODE_ENV !== "production" && module.hot) {
  module.hot.accept("./reducer/reducer", () =>
    store.replaceReducer(rootReducer)
  );
}

export { client, store, useDispatch, Provider };
